import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "11.9165",
      cy: "5.83331",
      r: "2.5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.9412 3.33335C10.598 2.36236 9.67201 1.66669 8.5835 1.66669C7.20278 1.66669 6.0835 2.78598 6.0835 4.16669C6.0835 5.5474 7.20278 6.66669 8.5835 6.66669C8.87569 6.66669 9.15618 6.61656 9.41683 6.52443",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.5835 16.6667H4.41683C4.41683 16.6667 7.41408 17.7001 9.41683 17.5001C11.5555 17.2864 15.0235 15.3123 16.3637 14.5066C16.7118 14.2974 16.9168 13.9208 16.9168 13.5147C16.9168 12.7182 16.1491 12.147 15.3862 12.3759L9.41683 14.1667",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.5835 12.0833L6.84669 10.9956C7.16788 10.8885 7.50747 10.8478 7.84487 10.8759L11.2808 11.1623C11.8431 11.2091 12.2406 11.7333 12.134 12.2874C12.0005 12.9815 11.4924 13.544 10.8153 13.7471L9.41683 14.1667",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }